<template>
  <div :class="$style.mobileControls">
    <BaseGrid container>
      <BaseGrid :sSize="12">
        <BaseButton
          v-if="$screen === 's' || $screen === 'm'"
          color="inverted"
          fullWidth
          @click="$emit('process')"
          v-test="'mobileControlsCancel'"
        >
          {{ $t('global.actions.cancel') }}
        </BaseButton>
      </BaseGrid>
      <BaseGrid
        v-if="selectedProducts.length"
        :sSize="6"
      >
        <BaseButton
          fullWidth
          @click="$emit('process')"
          v-test="'mobileControlsProceed'"
        >
          {{ $t('global.actions.proceed') }}
        </BaseButton>
      </BaseGrid>
    </BaseGrid>
  </div>
</template>

<script
  lang="ts"
  setup
>
defineProps({
  selectedProducts: {
    type: Array,
    required: true,
  },
});

defineEmits(['process']);
</script>

<style
  lang="scss"
  module
>
.mobileControls {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: $spacing;
  width: 100%;
  background-color: var(--color-bg);
  box-shadow: var(--shadow);
  z-index: 20;
  border-bottom-right-radius: $modal-radius;
  border-bottom-left-radius: $modal-radius;
}
</style>
